import {useEffect, useState} from "react";
import {Button, Checkbox, Col, Divider, Form, Input, message, Row, Select, Space} from "antd";
import {CheckboxChangeEvent} from "antd/es/checkbox";
import {BankDetailDtoTemp} from "../../dto/BankDetailDtoTemp";
import {CustomerWrapperDto} from "../../dto/CustomerWrapperDto";
import {BankDetailDto} from "../../dto/BankDetailDto";
import {InputDropdownParameterDto} from "../../dto/InputDropdownParameterDto";
import {ACCOUNT_NAME_VALIDATION, COMMON_DROPDOWN, ONLY_NUMERIC_VALIDATION, PARAMETER_LIST} from "../../util/Constants";
import {DropdownListDto} from "../../dto/DropdownListDto";
import Validation from "../../util/Validation";
import {toNumber} from "lodash";

import customerService from "../../service/customerService";
import ErrorHandler from "../../util/ErrorHandler";
import {MSG_FAILED_TO_FETCH_BANK_BRANCH_LIST_ERROR, MSG_FAILED_TO_FETCH_BANK_LIST_ERROR} from "../../util/Messages";
import {step_4_inactive_img} from '../../../AppImageConst';

const BANK_ACC_TYPE_PRIMARY = "PRIMARY"
const BANK_ACC_TYPE_SECONDARY = "SECONDARY"

interface OccupationDetailsPropData {
    savedCusDetailFromPreviousStep: CustomerWrapperDto
    getStepperFilledData: (data: CustomerWrapperDto) => void,
    switchStep?: () => void,
    isFromSummaryView: boolean
}

const BankAccountDetails = (props: OccupationDetailsPropData) => {
    const [form] = Form.useForm();
    const [isSecondaryAccountEnabled, setSecondaryAccountEnabled] = useState(false);
    const [{isSetSecondaryAccDataFilledAlready, secondaryAccData}, setSecondaryAccDataFilledAlready] =
        useState({
            isSetSecondaryAccDataFilledAlready: false,
            secondaryAccData: {
                accountHolderName: "",
                accountNo: "",
                branchId: 0,
                bankId: 0
            }
        });
    const [isSecondaryAccountSelected, setSecondarySelected] = useState(false);
    const [bankList, setBankList] = useState<DropdownListDto[]>([]);
    const [branchListPrimary, setBranchListPrimary] = useState<DropdownListDto[]>([]);
    const [branchListSec, setBranchListSecondary] = useState<DropdownListDto[]>([]);


    useEffect(() => {
        window.scrollTo(0, 0)
        getBankList()
        if (undefined != props.savedCusDetailFromPreviousStep.customerMstDto.bankDetailList?.length &&
            props.savedCusDetailFromPreviousStep.customerMstDto.bankDetailList?.length > 0) {
            console.log("setFieldValues")
            setFieldValues();
        }
    }, [])

    const setFieldValues = () => {
        console.log("setFieldValues =")
        const bankDetailList: BankDetailDto[] = undefined != props.savedCusDetailFromPreviousStep.customerMstDto.bankDetailList ?
            props.savedCusDetailFromPreviousStep.customerMstDto.bankDetailList : []
        let primaryAcc: BankDetailDto;
        let secondaryAcc: BankDetailDto;

        if (bankDetailList.length > 0) {
            primaryAcc = bankDetailList[0]
            getBranchList(primaryAcc.bankId, true)
            form.setFieldsValue(
                {
                    accountHolderName: primaryAcc.accountHolderName,
                    accountNo: primaryAcc.accountNo,
                    bankId: toNumber(primaryAcc.bankId),
                    branchId: toNumber(primaryAcc.branchId),

                }
            )

            if (bankDetailList.length > 1) {
                secondaryAcc = bankDetailList[1]
                getBranchList(secondaryAcc.bankId, false)
                setSecondarySelected(true)
                setSecondaryAccountEnabled(true)
                setSecondaryAccDataFilledAlready({
                    isSetSecondaryAccDataFilledAlready: true,
                    secondaryAccData: {
                        accountHolderName: secondaryAcc.accountHolderName,
                        accountNo: secondaryAcc.accountNo,
                        branchId: secondaryAcc.branchId,
                        bankId: secondaryAcc.bankId
                    }
                })
                form.setFieldsValue(
                    {
                        accountHolderNameSec: secondaryAcc.accountHolderName,
                        accountNoSec: secondaryAcc.accountNo,
                        branchIdSec: secondaryAcc.branchId,
                        bankIdSec: secondaryAcc.bankId,

                    }
                )

            } else {
                setSecondarySelected(false)
                setSecondaryAccountEnabled(false)
            }
        }


    }
    const onChangeBank = (selectedBranchId: number) => {
        form.resetFields(['branchId'])

        getBranchList(selectedBranchId, true)
    }
    const onChangeBankSec = (selectedBranchId: number) => {
        form.resetFields(['branchIdSec'])
        getBranchList(selectedBranchId, false)
    }
    const getBankList = () => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.BANK_LIST,
            findTextValue: "",
            parameterList: [PARAMETER_LIST.ACTIVE]
        }
        loadCommonDropdownDataList(inputDropdownParameterDto, COMMON_DROPDOWN.BANK_LIST);
    }
    const getBranchList = (selectedBank: number, isPrimaryAcc: boolean) => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.BRANCH_LIST,
            findTextValue: "",
            parameterList: [[selectedBank], [PARAMETER_LIST.ACTIVE]]
        }
        customerService.getCommonDropdown(inputDropdownParameterDto).then(res => {
            if (res.data !== null) {
                if (isPrimaryAcc) {
                    setBranchListPrimary(res.data.results.activeItemList)
                } else {
                    setBranchListSecondary(res.data.results.activeItemList)
                }
            } else {
                message.error(MSG_FAILED_TO_FETCH_BANK_BRANCH_LIST_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }
    const setType = (type: COMMON_DROPDOWN, result: DropdownListDto[]) => {
        if (type == COMMON_DROPDOWN.BANK_LIST) {
            setBankList(result)
        }
    }
    const loadCommonDropdownDataList = (dropDownParameterDto: InputDropdownParameterDto, type: COMMON_DROPDOWN) => {
        customerService.getCommonDropdown(dropDownParameterDto).then(res => {
            if (res.data !== null) {
                setType(type, res.data.results.activeItemList)
            } else {
                message.error(MSG_FAILED_TO_FETCH_BANK_LIST_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }
    const checkForFormChanges = (formValues: BankDetailDtoTemp, currentValues: BankDetailDto[]) => {


        const primaryAccTemp = currentValues.find((t: BankDetailDto) => t.bankAccountType === BANK_ACC_TYPE_PRIMARY);
        const secondaryTemp = currentValues.find((t: {
            bankAccountType: string;
        }) => t.bankAccountType === BANK_ACC_TYPE_SECONDARY);

        const primaryAcc = primaryAccTemp
        const secondaryAcc = secondaryTemp

        return (
            primaryAcc?.bankId !== formValues.bankId ||
            primaryAcc?.branchId !== formValues.branchId ||
            primaryAcc?.accountNo !== formValues.accountNo ||
            primaryAcc?.accountHolderName !== formValues.accountHolderName ||

            secondaryAcc?.bankId !== formValues.bankIdSec ||
            secondaryAcc?.branchId !== formValues.branchIdSec ||
            secondaryAcc?.accountNo !== formValues.accountNoSec ||
            secondaryAcc?.accountHolderName !== formValues.accountHolderNameSec

        );

    }
    const onFinishBankDetailUpdate = (val: BankDetailDtoTemp) => {
        let bankDetailList: BankDetailDto[] = [];
        let savedCusDetailFromPreviousStep: CustomerWrapperDto = props.savedCusDetailFromPreviousStep;

        if (savedCusDetailFromPreviousStep.customerMstDto.bankDetailList?.length) {

            if (checkForFormChanges(val, savedCusDetailFromPreviousStep.customerMstDto.bankDetailList)) {

                savedCusDetailFromPreviousStep.recordStatus = "UPDATE"
                savedCusDetailFromPreviousStep.isFinalStep = false
                savedCusDetailFromPreviousStep.currentActiveStep = savedCusDetailFromPreviousStep.completedStep
                const primaryAcc = savedCusDetailFromPreviousStep.customerMstDto.bankDetailList.find(
                    (t: BankDetailDto) => t.bankAccountType === BANK_ACC_TYPE_PRIMARY);
                const primaryBankDetail: BankDetailDto = {
                    id: primaryAcc?.id,
                    bankId: val.bankId,
                    branchId: val.branchId,
                    accountNo: val.accountNo,
                    accountHolderName: val.accountHolderName,
                    bankAccountType: BANK_ACC_TYPE_PRIMARY
                };
                bankDetailList.push(primaryBankDetail)

                let secondaryBankDetail: BankDetailDto = {
                    bankId: 0,
                    branchId: 0,
                    accountNo: "",
                    accountHolderName: "",
                    bankAccountType: "",
                }
                if (isSecondaryAccountEnabled) {
                    const secondaryAcc = savedCusDetailFromPreviousStep.customerMstDto.bankDetailList.find(
                        (t: BankDetailDto) => t.bankAccountType === BANK_ACC_TYPE_SECONDARY);

                    secondaryBankDetail = {
                        id: secondaryAcc?.id,
                        bankId: val.bankIdSec,
                        branchId: val.branchIdSec,
                        accountNo: val.accountNoSec,
                        accountHolderName: val.accountHolderNameSec,
                        bankAccountType: BANK_ACC_TYPE_SECONDARY
                    };
                    bankDetailList.push(secondaryBankDetail)
                }
                //function validateBankAccountsAreSame() checks whether the primary and secondary accounts same or not
                if (validateBankAccountsAreSame(primaryBankDetail, secondaryBankDetail, isSecondaryAccountEnabled)) {
                    message.warning("Secondary bank account details cannot be same as the primary account details!")
                } else {
                    savedCusDetailFromPreviousStep.customerMstDto.bankDetailList = bankDetailList;
                    props.getStepperFilledData(savedCusDetailFromPreviousStep);
                    console.log("update performed")
                }

            } else {
                console.log("just switch the step")
                if (props.switchStep) props.switchStep()
            }
        } else {
            const primaryBankDetail: BankDetailDto = {
                bankId: val.bankId,
                branchId: val.branchId,
                accountNo: val.accountNo,
                accountHolderName: val.accountHolderName,
                bankAccountType: BANK_ACC_TYPE_PRIMARY
            };
            bankDetailList.push(primaryBankDetail)
            let secondaryBankDetail: BankDetailDto = {
                bankId: 0,
                branchId: 0,
                accountNo: "",
                accountHolderName: "",
                bankAccountType: "",
            }
            if (isSecondaryAccountEnabled) {
                secondaryBankDetail = {
                    bankId: val.bankIdSec,
                    branchId: val.branchIdSec,
                    accountNo: val.accountNoSec,
                    accountHolderName: val.accountHolderNameSec,
                    bankAccountType: BANK_ACC_TYPE_SECONDARY
                };
                bankDetailList.push(secondaryBankDetail)
            }
            //function validateBankAccountsAreSame() checks whether the primary and secondary accounts same or not
            if (validateBankAccountsAreSame(primaryBankDetail, secondaryBankDetail, isSecondaryAccountEnabled)) {
                message.warning("Secondary bank account details cannot be same as the primary account details!")
            } else {
                savedCusDetailFromPreviousStep.customerMstDto.bankDetailList = bankDetailList;
                props.getStepperFilledData(savedCusDetailFromPreviousStep);
                console.log("save performed")
            }


        }

    }
    const validateBankAccountsAreSame = (primaryBankDetail: BankDetailDto, secondaryBankDetail: BankDetailDto, isSecEnabled: boolean) => {
        if (isSecEnabled) {
            return (primaryBankDetail.bankId == secondaryBankDetail.bankId &&
                primaryBankDetail.branchId == secondaryBankDetail.branchId &&
                primaryBankDetail.accountNo == secondaryBankDetail.accountNo)
        }
        return false

    }
    const onChangeSecondaryChk = (val: CheckboxChangeEvent) => {
        setSecondaryAccountEnabled(val.target.checked)
        setSecondarySelected(val.target.checked)
        setBranchListSecondary([])
        //this acction performed to handle the loss of sec account data in case user wants previose entered data -,
        //- that lost when tick the sec account check box
        if (isSetSecondaryAccDataFilledAlready) {
            if (!val.target.checked) {
                form.resetFields(['bankIdSec', 'branchIdSec', 'accountNoSec', 'accountHolderNameSec'])
            } else {
                getBranchList(secondaryAccData.bankId, false)
                form.setFieldsValue({
                    bankIdSec: secondaryAccData.bankId,
                    branchIdSec: secondaryAccData.branchId,
                    accountNoSec: secondaryAccData.accountNo,
                    accountHolderNameSec: secondaryAccData.accountHolderName,
                })
            }
        } else {

            if (!val.target.checked) {
                form.resetFields(['bankIdSec', 'branchIdSec', 'accountNoSec', 'accountHolderNameSec'])

            }
        }


    }

    return (
        <div>
            <p className='step_card_header'>
                <div className="icon-container">
                    <img className='header-icon-img' src={step_4_inactive_img}/>
                </div>
                About Your Bank
            </p>
            <Form
                className='form-input'
                layout={"vertical"}
                initialValues={{remember: true}}
                form={form}
                onFinish={onFinishBankDetailUpdate}
                disabled={props.isFromSummaryView}
            >
                <Row gutter={[32, 0]}>

                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Row>
                            <Col span={24} className='bank-account-header'>
                                <Checkbox checked disabled><h4 className='account-create-form-subheader'>Primary Bank
                                    Account Details</h4></Checkbox>
                            </Col>
                        </Row>
                        <Form.Item
                            label="Name of the Bank"
                            name={"bankId"}
                            rules={!props.isFromSummaryView ? [{
                                required: true,
                                message: 'Please select bank name'
                            }] : []}>
                            <Select placement='bottomLeft' onChange={onChangeBank} placeholder={"Select bank name"}
                                    showSearch listHeight={180}
                                    optionFilterProp="children"
                                    filterOption={(input: any, option: {
                                        label: any;
                                    }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                    getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                    options={bankList}
                            />

                        </Form.Item>
                        <Form.Item
                            label="Branch"
                            name={"branchId"}
                            rules={!props.isFromSummaryView ? [{
                                required: true,
                                message: 'Please select branch'
                            }] : []}>
                            <Select placement='bottomLeft' defaultSelected={""} placeholder={"Select branch"}
                                    showSearch listHeight={180}
                                    optionFilterProp="children"
                                    filterOption={(input: any, option: {
                                        label: any;
                                    }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                    getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                    options={branchListPrimary}
                            />

                        </Form.Item>
                        <Form.Item
                            label="Account Number"
                            name={"accountNo"}
                            onKeyPress={Validation.isNumberWithoutDot}
                            rules={!props.isFromSummaryView ? [
                                {required: true, message: 'Please enter account number'},
                                {
                                    max: 30,
                                    message: 'The maximum length is 30 numbers'
                                },
                                {
                                    pattern: ONLY_NUMERIC_VALIDATION,
                                    message: 'These special characters are not allowed'
                                }
                            ] : []}>
                            <Input placeholder={"Enter account number"}/>
                        </Form.Item>
                        <Form.Item
                            label="Account Holder`s Name"
                            name={"accountHolderName"}
                            onKeyPress={Validation.onlyAlphabeticWithSpace}
                            rules={!props.isFromSummaryView ? [{
                                required: true,
                                message: 'Please enter account holder`s name'
                            },
                                {
                                    max: 50,
                                    message: 'The maximum length is 50 characters'
                                },
                                {
                                    pattern: ACCOUNT_NAME_VALIDATION,
                                    message: 'Special characters and numbers are not allowed'
                                }
                            ] : []}>
                            <Input type="text" placeholder={"Enter account holder`s name"}/>
                        </Form.Item>

                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Row>
                            <Col span={24} className='bank-account-header'>
                                <Checkbox onChange={onChangeSecondaryChk} checked={isSecondaryAccountSelected}>
                                    <h4 className='account-create-form-subheader'>Secondary Bank Account Details</h4>
                                </Checkbox>
                            </Col>
                        </Row>

                        <Form.Item
                            label="Name of the Bank"
                            name={"bankIdSec"}
                            rules={!props.isFromSummaryView ? [isSecondaryAccountEnabled ? {
                                required: true,
                                message: 'Please select bank name'
                            } : {}] : []}>
                            <Select placement='bottomLeft' onChange={onChangeBankSec}
                                    disabled={!isSecondaryAccountEnabled || props.isFromSummaryView}
                                    showSearch listHeight={180}
                                    optionFilterProp="children"
                                    filterOption={(input: any, option: {
                                        label: any;
                                    }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                    getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                    placeholder={"Select bank name"} options={bankList}/>

                        </Form.Item>
                        <Form.Item
                            label="Branch"
                            name={"branchIdSec"}
                            rules={!props.isFromSummaryView ? [isSecondaryAccountEnabled ? {
                                required: true,
                                message: 'Please select branch'
                            } : {}] : []}>
                            <Select placement='bottomLeft'
                                    disabled={!isSecondaryAccountEnabled || props.isFromSummaryView}
                                    showSearch listHeight={180}
                                    optionFilterProp="children"
                                    filterOption={(input: any, option: {
                                        label: any;
                                    }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                    getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                    placeholder={"Select branch"} options={branchListSec}/>

                        </Form.Item>
                        <Form.Item
                            label="Account Number"
                            name={"accountNoSec"}
                            onKeyPress={Validation.isNumberWithoutDot}
                            rules={!props.isFromSummaryView ? [
                                {
                                    required: isSecondaryAccountEnabled,
                                    message: 'Please enter account number'
                                },
                                {
                                    max: 30,
                                    message: 'The maximum length is 30 numbers'
                                },
                                {
                                    pattern: ONLY_NUMERIC_VALIDATION,
                                    message: 'These special characters are not allowed'
                                }
                            ] : []}
                        >
                            <Input placeholder={"Enter account number"}
                                   disabled={!isSecondaryAccountEnabled || props.isFromSummaryView}/>
                        </Form.Item>
                        <Form.Item
                            label="Account Holder`s Name"
                            name={"accountHolderNameSec"}
                            onKeyPress={Validation.onlyAlphabeticWithSpace}
                            rules={!props.isFromSummaryView ? [
                                {
                                    required: isSecondaryAccountEnabled,
                                    message: 'Please enter account holder`s name'
                                },
                                {
                                    max: 50,
                                    message: 'The maximum length is 50 characters'
                                },
                                {
                                    pattern: ACCOUNT_NAME_VALIDATION,
                                    message: 'Special characters and numbers are not allowed'
                                }
                            ] : []}
                        >
                            <Input placeholder={"Enter account holder`s name"}
                                   disabled={!isSecondaryAccountEnabled || props.isFromSummaryView}/>
                        </Form.Item>

                    </Col>
                </Row>
                {
                    !props.isFromSummaryView ?
                        <>
                            <Row>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Divider></Divider>
                                </Col>
                            </Row>
                            <Space style={{float: 'right'}} className='form_next_btn_col'>
                                <Form.Item>
                                    <Button className='form_next_btn' htmlType="submit" type="primary">
                                        Next
                                    </Button>
                                </Form.Item>
                            </Space>
                        </> : ''
                }

            </Form>

        </div>
    )

}
export default BankAccountDetails;

